// Генерация CSS стилей для foliate-js
const getFoliateCSS = (
  readerTheme,
  { spacing = 1.4, justify = true, hyphenate = true, fontSize = 16 } = {}
) => {
  // Определяем конкретные цвета для темной и светлой темы
  const isDark = readerTheme === "dark";

  const colors = isDark
    ? {
        background: "#121212",
        text: "#ffffff",
        linkPrimary: "#90caf9",
        linkSecondary: "#ce93d8",
        codeBackground: "#1e1e1e",
        codeText: "#ffffff",
      }
    : {
        background: "#ffffff",
        text: "#000000",
        linkPrimary: "#1976d2",
        linkSecondary: "#9c27b0",
        codeBackground: "#f5f5f5",
        codeText: "#000000",
      };

  return `
    @namespace epub "http://www.idpf.org/2007/ops";
    
    html {
      color-scheme: ${isDark ? "dark" : "light"};
      background-color: ${colors.background} !important;
      color: ${colors.text} !important;
    }
    
    body {
      background-color: ${colors.background} !important;
      color: ${colors.text} !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
      font-size: ${fontSize}px !important;
    }
    
    /* Ссылки */
    a:link {
      color: ${colors.linkPrimary};
    }
    
    a:visited {
      color: ${colors.linkSecondary};
    }
    
    /* Текстовые элементы */
    p, li, blockquote, dd {
      line-height: ${spacing};
      text-align: ${justify ? "justify" : "start"};
      -webkit-hyphens: ${hyphenate ? "auto" : "manual"};
      hyphens: ${hyphenate ? "auto" : "manual"};
      -webkit-hyphenate-limit-before: 3;
      -webkit-hyphenate-limit-after: 2;
      -webkit-hyphenate-limit-lines: 2;
      hanging-punctuation: allow-end last;
      widows: 2;
      font-size: ${fontSize}px !important;
      color: ${colors.text} !important;
    }
    
    /* Заголовки */
    h1, h2, h3, h4, h5, h6 {
      color: ${colors.text} !important;
    }
    
    /* Выравнивание */
    [align="left"] { text-align: left; }
    [align="right"] { text-align: right; }
    [align="center"] { text-align: center; }
    [align="justify"] { text-align: justify; }

    /* Код */
    pre, code {
      white-space: pre-wrap !important;
      background-color: ${colors.codeBackground} !important;
      color: ${colors.codeText} !important;
      border-radius: 4px;
      padding: 0.2em 0.4em;
    }
    
    /* Скрываем сноски */
    aside[epub|type~="endnote"],
    aside[epub|type~="footnote"],
    aside[epub|type~="note"],
    aside[epub|type~="rearnote"] {
      display: none;
    }
  `;
};

export default getFoliateCSS;
